import { cn } from "@/lib/utils";

const LABELS: Record<string, string> = {
  seller_feedback_misplaced: "Off-topic seller feedback",
  conflict_of_interest: "Conflict of interest",
  incentivized: "Incentivized review",
  profanity_or_harassment: "Profanity / harassment",
  privacy_violation: "Privacy violation",
  off_topic: "Off-topic",
  duplicate_or_template: "Duplicate / template",
  manufacturer_misrepresentation: "Manufacturer misrepresentation",
  competitor_review: "Competitor review",
  review_swap: "Review swap",
};

export function ViolationBadge({ type, className }: { type: string; className?: string }) {
  const label = LABELS[type] ?? type;
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full bg-red-50 px-2 py-0.5 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-200",
        className
      )}
    >
      {label}
    </span>
  );
}
